export default {
    title: 'Title',
    description: 'Description',
    participants: 'Participants',

    cancel: 'Cancel',
    submit: 'Submit',

    validation: {
        title: {
            required: 'Please enter a title',
            length: 'The title should not contain more than 512 characters'
        },
        description: {
            required: 'Please enter a description',
            length: 'The description should not be longer than 4000 characters'
        }
    },

    success: 'The work space {title} was successfully created.'
}
